@if (!generalService.isSmallScreen()) {
  <div [class]="{ 'sheyda-card': true, 'show-preview-dialog': showPreviewDialog() }" (mouseleave)="handleLeaveOfCard()">
    <div class="badge-container">
      @if (Item().episode?.accessType) {
        @if (Item().episode!.accessType === accessTypes.Free) {
          <app-sheyda-badge Text="رایگان" />
        }
      }
      @if (Item().isExclusive) {
        <app-sheyda-badge [IsExclusive]="true" />
      }
    </div>
    <a
      class="image-box"
      routerLink="/p/{{ Item().uid }}"
      [ariaLabel]="Item().title"
      (mouseenter)="handleEnterOnCard()"
      (click)="handleLeaveOfCard()"
    >
      <app-image-generator
        [sizes]="imageSizes"
        [src]="Item().landscapeImagePath"
        [name]="Item().title"
        imageType="landscape"
      />
    </a>
    @if (isShowPreview()) {
      <div [class]="{ 'preview-container': true, 'show-preview': isViewPreview() }">
        <app-ghost-player
          (EndedVideo)="handleEndedTeaser($event)"
          (IsMuted)="handleInitialSetMute($event)"
          #ghostPlayer
        />
        <div class="mini-dialog-hero-layer"></div>
        <app-image-generator
          class="mini-dialog-logo-type"
          [src]="program()?.typoGraphyImagePath!"
          [name]="program()?.title"
          [sizes]="cardTypographySizes"
          [noBlurPlaceholder]="true"
          imageType="original"
        />
      </div>
    }
    <div class="sheyda-card-information">
      <div class="sheyda-card-info-box">
        <div class="program-operation-buttons">
          <div class="right-section">
            @if (programDetails()?.solitaryEpisode?.releaseStatus === "RELEASED") {
              <app-icon-button
                [IsButton]="true"
                class="play-btn"
                (Click)="handlePlayProgram()"
                Icon="play_arrow"
                Appearance="secondary"
                [IsFillIcon]="true"
                [WithTooltip]="true"
                TooltipText="تماشا"
              />
            }
            @if (program()) {
              <div class="bookmark-btn">
                <app-icon-button
                  [IsButton]="true"
                  (Click)="handleBookmark()"
                  Icon="bookmark"
                  [IsFillIcon]="program()?.isBookMarkedByMe!"
                  Appearance="accent"
                  [WithTooltip]="true"
                  [TooltipText]="program()?.isBookMarkedByMe ? 'حذف از لیست من' : 'اضافه به لیست من'"
                  [Loading]="submitBookmark()"
                />
              </div>
              <div class="interest-section">
                <div
                  [class]="{ 'interest-box': true, 'active-interest': showInterestSection() }"
                  (mouseenter)="handleShowHoveredElement()"
                  (mouseleave)="handleLeaveHoveredElement()"
                >
                  <app-icon-button
                    Appearance="default"
                    [IsButton]="true"
                    Icon="thumb_down"
                    [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Dislike"
                    [WithTooltip]="true"
                    TooltipText="نپسندیدم"
                    (Click)="handleInterestAction(interestAction.Dislike)"
                  />
                  <app-icon-button
                    Appearance="default"
                    Icon="thumb_up"
                    [IsButton]="true"
                    [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Like"
                    [WithTooltip]="true"
                    TooltipText="پسندیدم"
                    (Click)="handleInterestAction(interestAction.Like)"
                  />
                  <app-icon-button
                    Appearance="default"
                    Icon="favorite"
                    [IsButton]="true"
                    [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Love"
                    [WithTooltip]="true"
                    TooltipText="عاشقشم"
                    (Click)="handleInterestAction(interestAction.Love)"
                  />
                </div>
                <div class="like-btn" (mouseenter)="handleHoverOnLikeBtn()" (mouseleave)="handleLeaveOnLikeBtn()">
                  <app-icon-button
                    Appearance="accent"
                    [IsButton]="true"
                    [Loading]="submitInterest()"
                    (Click)="showInterestSection.set(true)"
                    [Icon]="
                      selectedInterest() && selectedInterest() === interestAction.Dislike
                        ? 'thumb_down'
                        : selectedInterest() && selectedInterest() === interestAction.Love
                          ? 'favorite'
                          : 'thumb_up'
                    "
                    [IsFillIcon]="selectedInterest() !== null"
                  />
                </div>
              </div>
              <div class="operation-buttons">
                @if (actionButtonType() === "mute") {
                  <app-icon-button Icon="no_sound" (Click)="unMuteTrailer()" Appearance="accent" [IsButton]="true" />
                }
                @if (actionButtonType() === "unmute") {
                  <app-icon-button Icon="volume_up" (Click)="muteTrailer()" Appearance="accent" [IsButton]="true" />
                }
                @if (actionButtonType() === "repeat") {
                  <app-icon-button Icon="replay" (Click)="replayTrailer()" Appearance="accent" [IsButton]="true" />
                }
              </div>
            }
          </div>
          <div class="left-section">
            <app-icon-button
              (Click)="generalService.router.navigateByUrl('/p/' + Item().uid)"
              Icon="more_horiz"
              Appearance="accent"
              [WithTooltip]="true"
              TooltipText="جزییات"
              [IsButton]="true"
            />
          </div>
        </div>
        <a class="program-title" routerLink="/p/{{ Item().uid }}" [title]="Item().title">{{ Item().title }}</a>
        <div class="program-genres">
          @if (programDetails()) {
            @if (programDetails()?.program?.statisticsDetails) {
              <span class="like-love-percentage"
                >{{
                  (programDetails()?.program)!.statisticsDetails.totalLovePercentage +
                    (programDetails()?.program)!.statisticsDetails.totalLikePercentage
                }}٪ پسندیدند</span
              >
            }

            @for (item of programDetails()?.genres; track $index) {
              <a routerLink="/g/{{ item?.descriptor }}">
                <span>{{ item?.name }}</span>
              </a>
            }
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="sheyda-card-mobile">
    <a routerLink="/p/{{ Item().uid }}">
      <app-image-generator
        [sizes]="imageSizes"
        [src]="Item().portraitImagePath"
        [name]="Item().title"
        imageType="portrait"
      />
      <div class="badge-container">
        @if (Item().episode?.accessType === accessTypes.Free) {
          <app-sheyda-badge Text="رایگان" />
        }
        @if (Item().isExclusive) {
          <app-sheyda-badge [IsExclusive]="true" />
        }
      </div>
    </a>
  </div>
}
